import axios from 'axios'
import qs from 'qs'
import router from './router'
import { Toast } from 'vant';
axios.defaults.timeout = 20000
axios.defaults.headers.common['X-Access-Device'] = 'WECHATWEB'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.baseURL = '/wxgzh/';
// window.baseURL = 'http://lwj.nps.qinyeit.com/wxgzh/';
window.softName = '智慧缴费系统';

// 添加一个请求拦截器
axios.interceptors.request.use(config => {
  if(window.localStorage.getItem("token")){
    config.headers["X-Access-Token"] = window.localStorage.getItem("token")
  }
  
  return config;
}, error => {
  // Do something with request error 
  return Promise.reject(error)
})
// 响应数据错误处理
const handleResponseDataError = response => {
  console.log(response.status)
  switch (response.status) {
    case -1001:
      break
    case 7001:
      Toast({ message: response.msg || '操作异常', type: 'fail', duration: 5 * 1000 })
      break
    case 504:
      Toast({ message: response.msg || '网关超时', type: 'fail', duration: 5 * 1000 })
    case 401:
      window.localStorage.removeItem("token")
      router.replace({path:'/'})
  }
}
// response interceptor
axios.interceptors.response.use(
  response => { // http响应状态码为200的情况
    const data = response.data
    handleResponseDataError(data)
    return data
  },
  error => {
    console.log("error", error.response);
    if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
      Toast({ message: '请求超时', type: 'fail', duration: 5 * 1000 })
      return Promise.reject(error.response.data);          // reject这个错误信息
    }
    if (error.message.includes('Network')) {   //判断服务器是否已断开
      Toast({ message: '服务器已断开或网络错误', type: 'fail', duration: 5 * 1000 })
      return Promise.reject(error.response.data);          // reject这个错误信息
    }
    if (error.response && error.response.data) {
      handleResponseDataError(error.response.data)
    }
    return Promise.reject(error.response.data);
  }
)
/**
 * 将对象转换为 name=hehe&age=10  这种格式，以便用 x-www-form-urlencoded 提交数据
 */
axios.toParams = function (data) {
  if (typeof data === 'string') return data
  if (typeof data === 'object') return qs.stringify(data, { arrayFormat: 'repeat', allowDots: true })
  return data
}

export default {
  /*
  *sign 是否签名 测试前注释 window.baseURL get  post postJSON 就这个三个就可以了
  */
  //  window.baseURL +
  post(url, data, timeout = 20000, sign = true) { //  post
    return axios.post(window.baseURL + url, axios.toParams(data), { timeout: timeout, sign: sign })
  },
  postJSON(url, data, timeout = 20000, sign = true) { //  post
    return axios.post(window.baseURL + url, data, { timeout: timeout, sign: sign })
  },
  put(url, data, sign = true) { //  put
    return axios.put(window.baseURL + url, axios.toParams(data), { sign: sign })
  },
  putJSON(url, data, sign = true) { //  put
    return axios.put(window.baseURL + url, data, { sign: sign })
  },
  get(url, data, timeout = 20000,sign = true) { // get
    return axios.get(window.baseURL + url, { params: data,timeout: timeout, sign: sign })
  },
  getApi(url, data, timeout = 20000, sign = true) {
    return axios.get(window.baseURL+url, { data, timeout: timeout, sign: sign })
  },
  getWxInfo(url, data, timeout = 20000, sign = true) {
    return axios.get(url, { data, timeout: timeout, sign: sign })
  },
  delete(url, data, sign = true) { // get
    return axios.delete(window.baseURL + url, data, { sign: sign })
  },
  download(url, data, sign = true) { // get
    return axios.get(window.baseURL + url, data, { sign: sign, responseType: 'blob' })
  },
  axios: axios,
  url: window.baseURL
}



// WEBPACK FOOTER //
// ./src/request.js